import { Text } from '@fluentui/react';
import React, { useMemo } from 'react';

const More = (props) => {

    const {
        label = "",
        onClick = (event) => console.log(event)
    } = props;

    const styles = useMemo(() => {
        return {
            root: {
                cursor: "pointer",
                fontWeight: 700,
                fontSize: 14,
                lineHeight: "20px",
                selectors: {
                    "::before": {
                        borderBottom: "2px solid red",
                        content: "''",
                        display: "inline-block",
                        minWidth: 50,
                        marginRight: 12,
                    }
                }
            }
        };
    }, []);

    return <Text onClick={onClick} styles={styles}>{label}</Text>;

};

export default More;